import React, { Component } from 'react';
import Table from 'rc-table';
import Modal from 'react-modal';
import Dialog from 'rc-dialog';
import 'rc-table/assets/index.css';

// Imports relativos.
import ActiveRow from './ActiveRow';
import TarjetaNumeroRow from './TarjetaNumeroRow';


/**
 * Insertar puntos decimales en un n�mero de tarjeta dado. 
 * @param {any} num - Numero para el cual insertar puntos decimales.
 */
function insertDecimalDots(num) {
    var str = num.toString().split('.');
    if (str[0].length >= 4) {
        str[0] = str[0].replace(/(\d)(?=(\d{3})+$)/g, '$1.');
    }
    if (str[1] && str[1].length >= 4) {
        str[1] = str[1].replace(/(\d{3})/g, '$1 ');
    }
    return str.join(',');
}


// Fila de v�nculo a tarjeta de cr�dito. 
const CreditCardLinkRow = ({ record, rowClickFn, text }) => {

    if (!record.childRow)
        return (
            <label>
                <b>{record.nombre}</b>
            </label>
        );

    return (
        <span>
            <span className="ti-credit-card CreditCardIcon">&nbsp;</span>
            <button type="button" className="btn btn-link" onClick={() => rowClickFn(record)} >
                <p className="CreditCardLink">{text}</p>
            </button>
        </span>
    );
};

const LimitRow = ({ isChildRow, text }) => {

    if (isChildRow)
        return <p className="RowText">${insertDecimalDots(text)}</p>
    else
        return null;
};

class TarjetasTable extends Component {

    constructor(props) {
        super(props);
        this.state = {
            modalTarjetaBorradaVisible: false,
            estadoBaja: null,
            modalTarjetaReimprimirVisible: false,
            estadoReimpresion: null,
            modalUsuarioNoAptoParaEdicion: false,
            modalAptoNuevaTarjeta: false
        };
    }

    toggleModalBorradaVisible(estadoBaja) {
        this.setState({ modalTarjetaBorradaVisible: !this.state.modalTarjetaBorradaVisible, estadoBaja: estadoBaja });
    }

    toggleModalReimprimirVisible(estadoReimpresion) {
        this.setState({ modalTarjetaReimprimirVisible: !this.state.modalTarjetaReimprimirVisible, estadoReimpresion: estadoReimpresion });
    }

    toggleModalUsuarioNoAptoParaEdicion() {
        this.setState({ modalUsuarioNoAptoParaEdicion: !this.state.modalUsuarioNoAptoParaEdicion });
    }

    toggleModalAptoNuevaTarjeta( cuenta ) {

        let result = this.props.plasticos.solicitudes.find( x => ( x.Estado.toLowerCase() !== 'o' || x.Estado.toLowerCase() === 'e') && x.NumeroCuenta == cuenta && x.Col1 == 120001 );

        if ( result == undefined || result.Estado.toLowerCase() == 'e' ) {
            var to = '#/tarjetas/Plasticos/DELIVERY/NuevaSolicitud/' + cuenta;
            location.href = to;
        } else {
            this.setState( { modalAptoNuevaTarjeta: true } );
        }
    }

    rowClickFn(row) {
        const { estadoBaja, cuentaNombre, cuentaNro, Col1 } = row;

        let estadoPlastico = row.estado;
        let solicitud = this.props.plasticos.solicitudes.find(x => parseInt(x.Col64) == parseInt(row.numero) && (x.Col1 == "210001" || x.Col1 == "210002" || x.Col1 == "170000" || x.Col1 == "190000"));

        if (estadoPlastico == 3) {
            this.toggleModalReimprimirVisible('o');
        }
        else if (solicitud !== undefined && (solicitud.Col1 == "210001" || solicitud.Col1 == "210002") || estadoPlastico == 0) {
            this.toggleModalBorradaVisible(estadoBaja);
        }
        else if (solicitud !== undefined && ( solicitud.Col1 == "190000") &&
            (solicitud.Estado.toLowerCase() == 'p' || solicitud.Estado.toLowerCase() == 't')) {
            this.toggleModalReimprimirVisible(estadoBaja);
        }
        else {
            if ((row.vinculoCuenta == row.vinculoTarjeta) || row.vinculoCuenta == 1) {
                const cuentaActual = { cuentas: cuentaNombre, numero: cuentaNro };
                this.props.cambiarPantalla('detalleApoderado', cuentaActual, row);
            } else if (row.numeroDocumento == this.props.plasticos.clienteResultadoBusqueda.NumeroDocumento) {
                const cuentaActual = { cuentas: cuentaNombre, numero: cuentaNro };
                this.props.cambiarPantalla('detalleApoderado', cuentaActual, row);
            } else {
                this.toggleModalUsuarioNoAptoParaEdicion(estadoBaja);
            }
        }
    }

    render() {

        const columns = [
            {
                title: 'CUENTA / TARJETAS',
                dataIndex: 'nombre',
                key: 'cuentas',
                render: (text, record) => <CreditCardLinkRow text={text} record={record} rowClickFn={(row) => this.rowClickFn(row)} />                
            },
            {
                title: ' ',
                dataIndex: 'numero',
                key: 'numero',
                render: (text, record) => <TarjetaNumeroRow isChildRow={record.childRow} tarjeta={record.tarjeta} numero={record.numero} />
            },
            {
                title: 'VINCULO',
                dataIndex: 'vinculo',
                key: 'vinculo',
                render: (text, record) => <p className={(record.childRow ? " " : "AcountLink ParentRowColumn")}>{text}</p>
            },
            {
                title: 'SUCURSAL',
                dataIndex: 'sucursal',
                key: 'sucursal',
                render: (text, record) => <p className={(record.childRow ? " " : "AcountLink ParentRowColumn")}>{text}</p>
            },
            {
                title: 'LIMITE',
                dataIndex: 'limite',
                key: 'limite',
                render: (text, record) => <LimitRow isChildRow={record.childRow} text={text} />
            },
            {
                title: ' ',
                dataIndex: '',
                key: 'x',
                render: ( text, record ) => record.vinculoId == 4 && !record.poseeCuentas ? <p>No permitido</p> : <ActiveRow newCard={record.newCard} numero={record.numero} estado={record.estado} isChildRow={record.childRow} estadoGlobal={this.props.plasticos} row={record} toggleModalAptoNuevaTarjeta={( cuenta ) => this.toggleModalAptoNuevaTarjeta( cuenta )} />
            }
        ];

        const { data, cambiarPantalla, plasticos } = this.props;

        let arrayResult = []
        let firstTime = true;
        let rowKey = 1;

        let texto1 = 'Este pl' + String.fromCharCode(225) + 'stico fue borrado.';
        let texto2 = 'Este pl' + String.fromCharCode(225) + 'stico est' + String.fromCharCode(225) + ' siendo borrado. Intente m' + String.fromCharCode(225) + 's tarde.';

        let texto1Reimpresion = 'Este pl' + String.fromCharCode(225) + 'stico fue reimpreso.';
        let texto2Reimpresion = 'Este pl' + String.fromCharCode(225) + 'stico est' + String.fromCharCode(225) + ' siendo reimpreso. Intente m' + String.fromCharCode(225) + 's tarde.';

        if (plasticos.cuentasDelivery && this.props.data.functions !== undefined) {
            if (this.props.data.functions.Socioversuc !== undefined || this.props.data.functions.Socioverbanco) {
                let tipoConsulta = "";
                if (this.props.data.functions.Socioverbanco) {
                    tipoConsulta = "BANCO";
                } else if (this.props.data.functions.Socioversuc) {
                    tipoConsulta = "SUCURSAL";
                }

                for (var i = 0; i < plasticos.cuentasDelivery.length; i++) {
                    let childrenArray = []
                    let sucursalId = plasticos.cuentasDelivery[i].Sucursal == null ? "" : plasticos.cuentasDelivery[i].Sucursal;

                    if (plasticos.tarjetas !== undefined && plasticos.tarjetas.length > 0) {
                        for (var j = 0; j < plasticos.tarjetas.length; j++) {
                            if (plasticos.cuentasDelivery[i].CodigoCuenta == plasticos.tarjetas[j].NumeroCuenta) {
                                if (plasticos.tarjetas[j].Numero.indexOf('-------') == -1) {

                                    let sucursal = plasticos.sucursalesDelivery.find(x => x.Codigo == plasticos.tarjetas[j].SucursalId);
                                    let sucursalDesc = sucursal !== undefined ? sucursal.Descripcion : '';

                                    let tipoCuenta = '';
                                    switch (plasticos.tarjetas[j].Vinculo.toString()) {
                                        case "1":
                                            tipoCuenta = 'Titular Princip';
                                            break
                                        case "2":
                                            tipoCuenta = 'Titular no Firm';
                                            break;
                                        case "3":
                                            tipoCuenta = 'Otro titular';
                                            break;
                                        case "4":
                                            tipoCuenta = 'Apoderado';
                                            break;
                                        case "5":
                                            tipoCuenta = 'Firmante';
                                            break;
                                        case "6":
                                            tipoCuenta = 'Rep. legal';
                                            break;
                                        default:
                                            tipoCuenta = '';
                                            break;
                                    }
                                    childrenArray.push({
                                        nombre: plasticos.tarjetas[j].Nombre,
                                        childRow: true,
                                        limite: plasticos.tarjetas[j].LimiteDescripcion,
                                        limite_codigo: plasticos.tarjetas[j].CodigoLimite,
                                        numero: plasticos.tarjetas[j].Numero,
                                        tarjeta: ( plasticos.tarjetas[j].DescripcionTarjeta.length > 24 ) ? plasticos.tarjetas[j].DescripcionTarjeta.slice(0,23) : plasticos.tarjetas[j].DescripcionTarjeta,
                                        vinculo: tipoCuenta,
                                        sucursal: plasticos.tarjetas[j].SucursalId == null ? 'Sin sucursal' : plasticos.tarjetas[j].SucursalId + ' - ' + sucursalDesc,
                                        estado: plasticos.tarjetas[j].Activo,
                                        cuentaNombre: plasticos.cuentasDelivery[i].NombreProducto,
                                        cuentaNro: plasticos.cuentasDelivery[i].CodigoCuenta.toString(),
                                        id_plastico: plasticos.tarjetas[j].id_plastico,
                                        estadoBaja: plasticos.tarjetas[j].estadoBaja,
                                        transaccionLink: plasticos.tarjetas[j].Col1 == null ? 'M' : plasticos.tarjetas[j].Col1,
                                        key: rowKey,
                                        numeroDocumento: plasticos.tarjetas[j].NumeroDocumento,
                                        vinculoCuenta: plasticos.cuentasDelivery[i].Vinculo,
                                        vinculoTarjeta: plasticos.tarjetas[j].Vinculo
                                    });
                                    rowKey++;
                                }
                            }
                        }
                    }

                    if (tipoConsulta == "BANCO" || (tipoConsulta == "SUCURSAL" && plasticos.cuentasDelivery[i].Sucursal == this.props.plasticos.sucursalUsuarioId)) {

                        let cuentaEstado = this.props.plasticos.consultaCuenta.find(x => x.Cuenta == plasticos.cuentasDelivery[i].CodigoCuenta.toString() && x.Sucursal == plasticos.cuentasDelivery[i].Sucursal);

                        let sucursal2 = plasticos.sucursalesDelivery.find(x => x.Codigo == sucursalId);
                        let sucursalDesc2 = sucursal2 !== undefined ? sucursal2.Descripcion : '';

                        if (cuentaEstado !== undefined) {

                            let tipoCuenta = '';
                            switch (plasticos.cuentasDelivery[i].Vinculo.toString()) {
                                case "1":
                                    tipoCuenta = 'Titular Princip';
                                    break
                                case "2":
                                    tipoCuenta = 'Titular no Firm';
                                    break;
                                case "3":
                                    tipoCuenta = 'Otro titular';
                                    break;
                                case "4":
                                    tipoCuenta = 'Apoderado';
                                    break;
                                case "5":
                                    tipoCuenta = 'Firmante';
                                    break;
                                case "6":
                                    tipoCuenta = 'Rep. legal';
                                    break;
                                default:
                                    tipoCuenta = '';
                                    break;
                            }

                            let estadoIbs = this.props.plasticos.estadosIbs.find(x => x.estctacod == cuentaEstado.EstCtaCod);
                            if (estadoIbs !== undefined && estadoIbs.Activo) {
                                arrayResult.push({
                                    nombre: plasticos.cuentasDelivery[i].NombreProducto,
                                    numero: plasticos.cuentasDelivery[i].CodigoCuenta.toString(),
                                    estadoBaja: plasticos.cuentasDelivery[i].estadoBaja,
                                    vinculo: tipoCuenta,
                                    vinculoId: plasticos.cuentasDelivery[i].Vinculo,
                                    sucursal: sucursalId == null ? 'Sin sucursal' : sucursalId + ' - ' + sucursalDesc2,
                                    childRow: false,
                                    limite: '',
                                    newCard: true,
                                    children: childrenArray,
                                    key: rowKey,
                                    poseeCuentas: plasticos.tarjetas.find(x => x.NumeroCuenta == plasticos.cuentasDelivery[i].CodigoCuenta) !== undefined ? true : false
                                });

                                rowKey++;
                            }
                        }
                    }
                }
            }

            let textoNoExistenTarjetas = "No existen cuentas/tarjetas para mostrar.";

            if (arrayResult.length == 0 && plasticos.cuentasDelivery.length > 0) {
                textoNoExistenTarjetas = "No existen cuentas/tarjetas asociadas a la sucursal del usuario."
            }

            return (
                <div className="TarjetasTable" style={{ marginLeft: '20px', marginRight: '20px' }}>
                    <h2 className="TarjetasTitle">Tarjetas</h2>
                    <Table
                        columns={columns}
                        data={arrayResult}
                        rowKey={record => record.key}
                        defaultExpandAllRows={true}
                        expandRowByClick={false}
                        expandIconAsCell={true}
                        cambiarPantalla={cambiarPantalla}
                        emptyText={textoNoExistenTarjetas}
                        className="table-style-seleccionar-cuenta TablaVistaCliente"
                    />
                    <div>
                        <Dialog
                            visible={this.state.modalTarjetaBorradaVisible}
                            onClose={() => this.toggleModalBorradaVisible(this.state.estadoBaja)}
                            animation="slide-fade"
                            maskAnimation="fade"
                            style={{ width: 600 }}
                            title={"Atenci" + String.fromCharCode(243) + "n"}
                            footer={[
                                <button type="button" className="btn btn-default" key="close" onClick={() => this.toggleModalBorradaVisible(this.state.estadoBaja)}>
                                    Cerrar
                     </button>
                            ]}>
                            {(this.state.estadoBaja !== null && this.state.estadoBaja !== undefined && this.state.estadoBaja.toLowerCase() === 'o') ? <p>{texto1}</p> : <p>{texto2}</p>}
                        </Dialog>
                    </div>

                    <div>
                        <Dialog
                            visible={this.state.modalTarjetaReimprimirVisible}
                            onClose={() => this.toggleModalReimprimirVisible(this.state.estadoReimpresion)}
                            animation="slide-fade"
                            maskAnimation="fade"
                            style={{ width: 600 }}
                            title={"Atenci" + String.fromCharCode(243) + "n"}
                            footer={[<button type="button" className="btn btn-default" key="close" onClick={() => this.toggleModalReimprimirVisible(this.state.estadoReimpresion)}>
                                Cerrar
                            </button>
                            ]}>
                            {(this.state.estadoReimpresion !== null && this.state.estadoReimpresion !== undefined && this.state.estadoReimpresion.toLowerCase() === 'o') ? <p>{texto1Reimpresion}</p> : <p>{texto2Reimpresion}</p>}
                        </Dialog>
                    </div>

                    <div>
                        <Dialog
                            visible={this.state.modalUsuarioNoAptoParaEdicion}
                            onClose={() => this.toggleModalUsuarioNoAptoParaEdicion()}
                            animation="slide-fade"
                            maskAnimation="fade"
                            style={{ width: 600 }}
                            title={"Atenci" + String.fromCharCode(243) + "n"}
                            footer={[<button type="button" className="btn btn-default" key="close" onClick={() => this.toggleModalUsuarioNoAptoParaEdicion()}>
                                Cerrar
                            </button>
                            ]}>
                            <p>{"El pl" + String.fromCharCode(225) + "stico seleccionado solo puede ser editado por el titular."}</p>
                        </Dialog>
                    </div>

                    <div>
                        <Dialog
                            visible={this.state.modalAptoNuevaTarjeta}
                            onClose={() => this.setState( { modalAptoNuevaTarjeta: false } )}
                            animation="slide-fade"
                            maskAnimation="fade"
                            style={{ width: 600 }}
                            title={"Atenci" + String.fromCharCode( 243 ) + "n"}>
                            <p>No puede agregar una tarjeta, si la del titular se encuentra en tramite.</p>
                        </Dialog>
                    </div>

                </div >
            );

        }
        else {
            return <label>El cliente no posee cuentas.</label>;
        }
    }
}


export default TarjetasTable;